import { z } from "zod";

export const EnderecoAtualSchema = z.object({
  id: z.number(),
  userId: z.number(),
  nome: z.string(),
  telefone: z.string(),
  latitude: z.union([z.string(), z.number()]).transform((val) => Number(val)),
  longitude: z.union([z.string(), z.number()]).transform((val) => Number(val)),
  estado: z.string(),
  cidade: z.string(),
  logradouro: z.string(),
  bairro: z.string(),
  numero: z.string(),
  referencia: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const UpsertEnderecoAtualSchema = z.object({
  nome: z.string().max(64),
  telefone: z.string().regex(/^\d{10,11}$/),
  latitude: z.number(),
  longitude: z.number(),
  estado: z.string().max(32),
  cidade: z.string().max(32),
  logradouro: z.string().max(128),
  bairro: z.string().max(64),
  numero: z.string().max(8),
  referencia: z.string().max(64).optional(),
});

export type EnderecoAtual = z.infer<typeof EnderecoAtualSchema>;
export type UpsertEnderecoAtualDto = z.infer<typeof UpsertEnderecoAtualSchema>;
